import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogType,
  DialogFooter,
} from 'office-ui-fabric-react/lib/Dialog';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import './TermsAndConditionsDialog.css';

export const TermsAndConditionsDialog = ({
  termsAndConditionsDialogHidden,
  closeDialog,
  acceptTermsFromDialog,
}) => (
  <Dialog
    hidden={termsAndConditionsDialogHidden}
    onDismiss={closeDialog}
    dialogContentProps={{
      type: DialogType.largeHeader,
      title: 'Terms And Conditions',
    }}
    modalProps={{
      isBlocking: false,
      containerClassName: 'TermsAndConditionsDialog',
    }}
  >
    <div className="terms-and-conditions">
      <h4>Agreement Between User and FrontRunner</h4>
      <p>
        {`Welcome to FrontRunner. The FrontRunner website (the "Site") is comprised of various web pages operated by FrontRunner Edge LLC ("FrontRunner").
            FrontRunner is offered to you conditioned on your acceptance without modification of the terms, conditions, and notices contained herein
            (the "Terms"). Your use of FrontRunner constitutes your agreement to all such Terms. Please read these terms carefully, and keep a copy of
            them for your reference.`}
      </p>

      <p>
        {
          'FrontRunner is a campaign finance administration and disclosure-reporting platform Site.'
        }
      </p>

      <p>
        {`FrontRunner is an electronic filing platform that will allow candidates and committees to key-data-enter report data, manage and
            electronically submit said data to the appropriate regulatory authority.`}
      </p>

      <h4>Electronic Communications</h4>
      <p>
        {`Visiting FrontRunner or sending emails to FrontRunner constitutes electronic communications. You consent to receive electronic communications
            and you agree that all agreements, notices, disclosures and other communications that we provide to you electronically, via email and on the
            Site, satisfy any legal requirement that such communications be in writing.`}
      </p>

      <h4>Your Account</h4>
      <p>
        {`If you use this site, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your
            computer, and you agree to accept responsibility for all activities that occur under your account or password. You may not assign or otherwise
            transfer your account to any other person or entity. You acknowledge that FrontRunner is not responsible for third party access to your account
            that results from theft or misappropriation of your account. FrontRunner and its associates reserve the right to refuse or cancel service,
            terminate accounts, or remove or edit content in our sole discretion.`}
      </p>

      <p>
        {`FrontRunner does not knowingly collect, either online or offline, personal information from persons under the age of thirteen. If you are under 18,
            you may use FrontRunner only with permission of a parent or guardian.`}
      </p>

      <h4>Links to Third Party Sites/Third Party Services</h4>
      <p>
        {`FrontRunner may contain links to other websites ("Linked Sites"). The Linked Sites are not under the control of FrontRunner and FrontRunner is not
            responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site, or any changes or updates to a
            Linked Site. FrontRunner is providing these links to you only as a convenience, and the inclusion of any link does not imply endorsement by
            FrontRunner of the site or any association with its operators.`}
      </p>

      <p>
        {`Certain services made available via FrontRunner are delivered by third party sites and organizations. By using any product, service or functionality
            originating from the FrontRunner domain, you hereby acknowledge and consent that FrontRunner may share such information and data with any third party
            with whom FrontRunner has a contractual relationship to provide the requested product, service or functionality on behalf of FrontRunner users and
            customers.`}
      </p>

      <h4>No Unlawful or Prohibited Use/Intellectual Property</h4>
      <p>
        {`You are granted a non-exclusive, non-transferable, revocable license to access and use FrontRunner strictly in accordance with these terms of use.
            As a condition of your use of the Site, you warrant to FrontRunner that you will not use the Site for any purpose that is unlawful or prohibited by
            these Terms. You may not use the Site in any manner which could damage, disable, overburden, or impair the Site or interfere with any other party's
            use and enjoyment of the Site. You may not obtain or attempt to obtain any materials or information through any means not intentionally made
            available or provided for through the Site.`}
      </p>

      <p>
        {`All content included as part of the Service, such as text, graphics, logos, images, as well as the compilation thereof, and any software used on
            the Site, is the property of FrontRunner or its suppliers and protected by copyright and other laws that protect intellectual property and proprietary
            rights. You agree to observe and abide by all copyright and other proprietary notices, legends or other restrictions contained in any such content and
            will not make any changes thereto.`}
      </p>

      <p>
        {`You will not modify, publish, transmit, reverse engineer, participate in the transfer or sale, create derivative works, or in any way exploit any of
            the content, in whole or in part, found on the Site. FrontRunner content is not for resale. Your use of the Site does not entitle you to make any
            unauthorized use of any protected content, and in particular you will not delete or alter any proprietary rights or attribution notices in any content.
            You will use protected content solely for your personal use, and will make no other use of the content without the express written permission of FrontRunner
            and the copyright owner. You agree that you do not acquire any ownership rights in any protected content. We do not grant you any licenses, express or implied,
            to the intellectual property of FrontRunner or our licensors except as expressly authorized by these Terms.`}
      </p>

      <h4>Use of Communication Services</h4>
      <p>
        {`The Site may contain bulletin board services, chat areas, news groups, forums, communities, personal web pages, calendars, and/or other message or
            communication facilities designed to enable you to communicate with the public at large or with a group (collectively, "Communication Services"),
            you agree to use the Communication Services only to post, send and receive messages and material that are proper and related to the particular
            Communication Service.`}
      </p>

      <p>
        {`By way of example, and not as a limitation, you agree that when using a Communication Service, you will not: defame, abuse, harass, stalk, threaten or otherwise
            violate the legal rights (such as rights of privacy and publicity) of others; publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory,
            infringing, obscene, indecent or unlawful topic, name, material or information; upload files that contain software or other material protected by intellectual property
            laws (or by rights of privacy of publicity) unless you own or control the rights thereto or have received all necessary consents; upload files that contain viruses,
            corrupted files, or any other similar software or programs that may damage the operation of another's computer; advertise or offer to sell or buy any goods or services
            for any business purpose, unless such Communication Service specifically allows such messages; conduct or forward surveys, contests, pyramid schemes or chain letters;
            download any file posted by another user of a Communication Service that you know, or reasonably should know, cannot be legally distributed in such manner; falsify or
            delete any author attributions, legal or other proper notices or proprietary designations or labels of the origin or source of software or other material contained in a
            file that is uploaded, restrict or inhibit any other user from using and enjoying the Communication Services; violate any code of conduct or other guidelines which may be
            applicable for any particular Communication Service; harvest or otherwise collect information about others, including e-mail addresses, without their consent;
            violate any applicable laws or regulations.`}
      </p>

      <p>
        {`FrontRunner has no obligation to monitor the Communication Services. However, FrontRunner reserves the right to review materials posted to a Communication Service and to
            remove any materials in its sole discretion. FrontRunner reserves the right to terminate your access to any or all of the Communication Services at any time without notice
            for any reason whatsoever.`}
      </p>

      <p>
        {`FrontRunner reserves the right at all times to disclose any information as necessary to satisfy any applicable law, regulation, legal process or governmental request, or to
            edit, refuse to post or to remove any information or materials, in whole or in part, in FrontRunner's sole discretion.`}
      </p>

      <p>
        {`Always use caution when giving out any personally identifying information about yourself or your children in any Communication Service. FrontRunner does not control or endorse
            the content, messages or information found in any Communication Service and, therefore, FrontRunner specifically disclaims any liability with regard to the Communication Services
            and any actions resulting from your participation in any Communication Service. Managers and hosts are not authorized FrontRunner spokespersons, and their views do not
            necessarily reflect those of FrontRunner.`}
      </p>

      <p>
        {`Materials uploaded to a Communication Service may be subject to posted limitations on usage, reproduction and/or dissemination. You are responsible for adhering to such
            limitations if you upload the materials.`}
      </p>

      <h4>
        Materials Provided to FrontRunner or Posted on any FrontRunner Web Page
      </h4>
      <p>
        {`FrontRunner does not claim ownership of the materials you provide to FrontRunner (including feedback and suggestions) or post, upload, input or submit to any FrontRunner Site or
            our associated services (collectively "Submissions"). However, by posting, uploading, inputting, providing or submitting your Submission you are granting FrontRunner, our
            affiliated companies and necessary sublicensees permission to use your Submission in connection with the operation of their Internet businesses including, without limitation, the
            rights to: copy, distribute, transmit, publicly display, publicly perform, reproduce, edit, translate and reformat your Submission; and to publish your name in connection with your
            Submission.`}
      </p>

      <p>
        {`No compensation will be paid with respect to the use of your Submission, as provided herein. FrontRunner is under no obligation to post or use any Submission you may provide and
            may remove any Submission at any time in FrontRunner's sole discretion.`}
      </p>

      <p>
        {`By posting, uploading, inputting, providing or submitting your Submission you warrant and represent that you own or otherwise control all of the rights to your Submission as described
            in this section including, without limitation, all the rights necessary for you to provide, post, upload, input or submit the Submissions.`}
      </p>

      <h4>International Users</h4>
      <p>
        {`The Service is controlled, operated and administered by FrontRunner from our offices within the USA. If you access the Service from a location outside the USA, you are responsible for
            compliance with all local laws. You agree that you will not use the FrontRunner Content accessed through FrontRunner in any country or in any manner prohibited by any applicable laws,
            restrictions or regulations.`}
      </p>

      <h4>Indemnification</h4>
      <p>
        {`You agree to indemnify, defend and hold harmless FrontRunner, its officers, directors, employees, agents and third parties, for any losses, costs, liabilities and expenses (including
            reasonable attorneys&apos; fees) relating to or arising out of your use of or inability to use the Site or services, any user postings made by you, your violation of any terms of this
            Agreement or your violation of any rights of a third party, or your violation of any applicable laws, rules or regulations. FrontRunner reserves the right, at its own cost, to assume
            the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will fully cooperate with FrontRunner in asserting any available defenses.`}
      </p>

      <h4>Liability Disclaimer</h4>
      <p>
        {`THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE
            INFORMATION HEREIN. FRONTRUNNER EDGE LLC AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE SITE AT ANY TIME.`}
      </p>

      <p>
        {`FRONTRUNNER EDGE LLC AND/OR ITS SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES
            AND RELATED GRAPHICS CONTAINED ON THE SITE FOR ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS ARE
            PROVIDED "AS IS" WITHOUT WARRANTY OR CONDITION OF ANY KIND. FRONTRUNNER EDGE LLC AND/OR ITS SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE,
            PRODUCTS, SERVICES AND RELATED GRAPHICS, INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.`}
      </p>

      <p>
        {`TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL FRONTRUNNER EDGE LLC AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL
            DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE OF THE SITE,
            WITH THE DELAY OR INABILITY TO USE THE SITE OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS
            OBTAINED THROUGH THE SITE, OR OTHERWISE ARISING OUT OF THE USE OF THE SITE, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF FRONTRUNNER EDGE LLC OR ANY OF ITS
            SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES,
            THE ABOVE LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE
            SITE.`}
      </p>

      <h4>Termination/Access Restriction</h4>
      <p>
        {`In the event of non-payment based on the user license agreement, FrontRunner reserves the right, in its sole discretion, to terminate your access to the Site and the related services or
            any portion thereof at any time, without notice. To the maximum extent permitted by law, this agreement is governed by the laws of the State of Georgia and you hereby consent to the exclusive
            jurisdiction and venue of courts in Georgia in all disputes arising out of or relating to the use of the Site. Use of the Site is unauthorized in any jurisdiction that does not give effect to
            all provisions of these Terms, including, without limitation, this section.`}
      </p>

      <p>
        {`You agree that no joint venture, partnership, employment, or agency relationship exists between you and FrontRunner as a result of this agreement or use of the Site. FrontRunner&apos;s performance of
            this agreement is subject to existing laws and legal process, and nothing contained in this agreement is in derogation of FrontRunner's right to comply with governmental, court and law enforcement
            requests or requirements relating to your use of the Site or information provided to or gathered by FrontRunner with respect to such use. If any part of this agreement is determined to be invalid
            or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be
            deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the agreement shall continue in effect.`}
      </p>

      <p>
        {`Unless otherwise specified herein, this agreement constitutes the entire agreement between the user and FrontRunner with respect to the Site and it supersedes all prior or contemporaneous communications
            and proposals, whether electronic, oral or written, between the user and FrontRunner with respect to the Site. A printed version of this agreement and of any notice given in electronic form shall be
            admissible in judicial or administrative proceedings based upon or relating to this agreement to the same extent an d subject to the same conditions as other business documents and records originally
            generated and maintained in printed form. It is the express wish to the parties that this agreement and all related documents be written in English.`}
      </p>

      <h4>Changes to Terms</h4>
      <p>
        {`FrontRunner reserves the right, in its sole discretion, to change the Terms under which FrontRunner is offered. The most current version of the Terms will supersede all previous versions.
            FrontRunner encourages you to periodically review the Terms to stay informed of our updates.`}
      </p>

      <h4>Contact Us</h4>
      <p>
        FrontRunner welcomes your questions or comments regarding the Terms:
      </p>

      <address>
        <strong style={{ display: 'block' }}>FRONTRUNNER EDGE LLC</strong>
        <strong style={{ display: 'block' }}>PO Box 1</strong>
        <strong style={{ display: 'block' }}>Roswell, Georgia 30077</strong>
      </address>

      <h4>Email Address:</h4>
      <span>info@frontrunneredge.com</span>

      <p>
        <em>Effective as of January 1, 2026</em>
      </p>
    </div>
    <DialogFooter>
      <div className="footer">
        <DefaultButton
          onClick={closeDialog}
          text="Close"
          className="cancel-btn"
        />
        <PrimaryButton onClick={acceptTermsFromDialog} text="Accept Terms" />
      </div>
    </DialogFooter>
  </Dialog>
);

TermsAndConditionsDialog.propTypes = {
  termsAndConditionsDialogHidden: PropTypes.bool,
  closeDialog: PropTypes.func.isRequired,
  acceptTermsFromDialog: PropTypes.func.isRequired,
};

export default TermsAndConditionsDialog;
